import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SeFeAvatarModule } from 'se-fe-avatar'
import { ProfileBarComponent } from './profile-bar/profile-bar.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeAvatarModule
  ],
  declarations: [ProfileBarComponent],
  exports: [ProfileBarComponent],
})
export class SharedUiProfileBarModule {}
